// The little duck from the client app's Ducks in a Row (sidekick-client
// lib/celebrate.ts DUCK_PATH), so a sorted duck looks the same on both sides.
const DUCK_PATH =
  "M2 16C2 10 8 12 14 13L22 13C20 11 19 9 19 7C19 3 22 1 26 1C30 1 33 4 33 7C33 9 32 10.5 31 11.5C35 13 38 16 38 20C38 25 33 27 26 27L12 27C6 27 2 23 2 16Z";

/** The duck-yellow of a sorted duck, as in the client app. */
export const DUCK_SORTED_CLASS = "text-[#E3B341]";
/** A duck that isn't sorted yet. */
export const DUCK_UNSORTED_CLASS = "text-slate-200 dark:text-slate-700";

export function DuckMark({
  size = 16,
  className,
  title,
}: {
  size?: number;
  className?: string;
  title?: string;
}) {
  return (
    <svg
      viewBox="0 0 40 28"
      width={size}
      height={(size * 28) / 40}
      className={className}
      aria-hidden={title ? undefined : true}
      role={title ? "img" : undefined}
    >
      {title && <title>{title}</title>}
      <path fill="currentColor" d={DUCK_PATH} />
    </svg>
  );
}
